/* 블로그 구독 드로워 — 워드프레스판에서 그대로 옮겨 왔다. 손대지 않았다.
   보내는 곳: https://orbitools.orbiters.co.kr/api/onzenna/blog/subscribe/
   계약: POST {email, children:[{dob}], is_expecting, consent_text, page} → {ok:true} |
        {ok:false, error:"suppressed"|"bad_email"|"rate_limited"}
   ⚠️ 브라우저에 자격증명이 하나도 없다 — 서버가 Klaviyo·Shopify·DataKeeper 를 대신 부른다. */
(function(){
  var el=document.getElementById('onz-sub'); if(!el) return;
  var KEY='onz_sub_state_v1', DAYS=1;
  // 글 상세에서만 30% 스크롤에 자동 펼침 — 워드프레스판의 is_single() 과 같다. 옮길 때 false 로
  // 굳어 빠졌다(2026-10-27 복구). 글 상세 여부는 스니펫이 data-auto="1" 로 넘긴다.
  var AUTO=el.getAttribute('data-auto')==='1', PCT=30;
  var bar=el.querySelector('.onz-sub__bar'), form=el.querySelector('.onz-sub__form');
  var kids=el.querySelector('.onz-sub__kids'), expecting=el.querySelector('.onz-sub__expecting');
  var errBox=el.querySelector('.onz-sub__err'), done=el.querySelector('.onz-sub__done');
  var addBtn=el.querySelector('[data-act="add"]'), noneBtn=el.querySelector('[data-act="none"]');
  var submitBtn=el.querySelector('.onz-sub__submit');

  function read(){ try{ return JSON.parse(localStorage.getItem(KEY)||'{}'); }catch(e){ return {}; } }
  function write(o){ try{ localStorage.setItem(KEY, JSON.stringify(o)); }catch(e){} }
  var st=read();
  // 구독 여부로 숨기지 않는다(2026-08-27 사용자 결정). 이 표식은 브라우저마다 따로라
  // 같은 사람이 폰에서 구독해도 PC 에선 안 남고, Klaviyo 에서 지워도 여기엔 남는다 —
  // 즉 '구독자인가'를 판정할 수 없는 값으로 화면을 가리고 있었다. 판정 자체를 없앤다.
  el.hidden=false;

  function suppressed(){ return st.dismissedUntil && Date.now() < st.dismissedUntil; }

  // 하루 억제는 **자동으로 뜬 것을 닫았을 때만** 건다(사용자 결정 2026-08-25).
  // 자동 펼침 전에 스스로 열어봤다가 접는 건 '관심 없음'이 아니라 그냥 미리 본 것이다 —
  // 그걸로 억제하면 정작 자동 펼침이 한 번도 안 뜬다.
  var autoOpened = false;

  function open(byAuto){
    el.classList.add('is-open'); el.classList.remove('is-collapsed');
    bar.setAttribute('aria-expanded','true');
    if(byAuto) autoOpened = true;
  }
  function collapse(byUser){
    el.classList.remove('is-open'); el.classList.add('is-collapsed');
    bar.setAttribute('aria-expanded','false');
    if(byUser && autoOpened){ st.dismissedUntil = Date.now() + DAYS*864e5; write(st); }
  }
  bar.addEventListener('click', function(){
    el.classList.contains('is-open') ? collapse(true) : open(false);
  });

  // 아티클 30% 스크롤 시 1회 자동 펼침. 사용자가 닫았으면 억제 기간 동안 열지 않는다.
  if(AUTO && !suppressed()){
    var fired=false;
    var onScroll=function(){
      if(fired) return;
      var d=document.documentElement, max=d.scrollHeight-d.clientHeight;
      if(max<=0) return;
      if((d.scrollTop||document.body.scrollTop)/max*100 >= PCT){
        fired=true; window.removeEventListener('scroll', onScroll);
        // 억제는 발화 시점에 다시 본다(다른 탭·앞선 방문에서 자동 펼침을 닫았을 수 있다).
        if(suppressed()) return;
        if(!el.classList.contains('is-open')) open(true);
      }
    };
    window.addEventListener('scroll', onScroll, {passive:true});
  }

  var MONTHS=['January','February','March','April','May','June',
              'July','August','September','October','November','December'];
  var MON3=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var DOW=['Su','Mo','Tu','We','Th','Fr','Sa'];
  var NOW=new Date(), Y1=NOW.getFullYear()+1, Y0=NOW.getFullYear()-12;   // 출산예정일(미래)~12세
  var pad=function(n){ return n<10 ? '0'+n : ''+n; };
  var iso=function(y,m,d){ return y+'-'+pad(m+1)+'-'+pad(d); };
  var openCal=null;   // 한 번에 하나만 열어둔다

  // 브라우저 기본 캘린더는 선택색(파랑)과 표기 언어를 CSS 로 못 바꾼다.
  // 폼 톤(크림·온제나 그린·영문)에 맞추려면 같은 모양을 직접 그리는 수밖에 없다.
  function makeDatePicker(){
    var wrap=document.createElement('div'); wrap.className='onz-sub__dob';
    var btn=document.createElement('button');
    btn.type='button'; btn.className='onz-sub__date'; btn.setAttribute('data-empty','1');
    btn.textContent='Select date';
    var ico=document.createElement('span'); ico.className='onz-sub__cal-ico'; ico.setAttribute('aria-hidden','true');
    var cal=document.createElement('div'); cal.className='onz-sub__cal'; cal.hidden=true;
    cal.setAttribute('role','dialog'); cal.setAttribute('aria-label','Choose a date');
    wrap.appendChild(btn); wrap.appendChild(ico); wrap.appendChild(cal);

    var value=null;                                  // {y,m,d} — 확정된 선택
    var view={ y: NOW.getFullYear(), m: NOW.getMonth() };
    var mode='days';

    function label(){
      if(!value){ btn.textContent='Select date'; btn.setAttribute('data-empty','1'); return; }
      btn.textContent = MON3[value.m]+' '+value.d+', '+value.y;
      btn.removeAttribute('data-empty');
    }
    function close(){ cal.hidden=true; mode='days'; if(openCal===cal) openCal=null; }
    function draw(){
      cal.innerHTML='';
      var head=document.createElement('div'); head.className='onz-sub__cal-head';
      var title=document.createElement('div'); title.className='onz-sub__cal-title';
      var mon=document.createElement('button'); mon.type='button'; mon.className='onz-sub__cal-mon';
      mon.textContent=MONTHS[view.m];
      mon.setAttribute('aria-expanded', mode==='months' ? 'true' : 'false');
      var yr=document.createElement('button'); yr.type='button'; yr.className='onz-sub__cal-yr';
      yr.textContent=view.y; yr.setAttribute('aria-label','Choose year');
      yr.setAttribute('aria-expanded', mode==='years' ? 'true' : 'false');
      yr.addEventListener('click', function(){ mode = mode==='years' ? 'days' : 'years'; draw(); });
      mon.addEventListener('click', function(){ mode = mode==='months' ? 'days' : 'months'; draw(); });
      title.appendChild(mon); title.appendChild(yr);
      var nav=document.createElement('div'); nav.className='onz-sub__cal-nav';
      var prev=document.createElement('button'); prev.type='button'; prev.innerHTML='&#9664;';
      prev.setAttribute('aria-label','Previous month');
      var next=document.createElement('button'); next.type='button'; next.innerHTML='&#9654;';
      next.setAttribute('aria-label','Next month');
      prev.addEventListener('click', function(){ shift(-1); });
      next.addEventListener('click', function(){ shift(1); });
      nav.appendChild(prev); nav.appendChild(next);
      head.appendChild(title); head.appendChild(nav);
      cal.appendChild(head);

      if(mode==='months'){
        var ms=document.createElement('div'); ms.className='onz-sub__cal-years';
        MONTHS.forEach(function(name, k){
          var bm=document.createElement('button'); bm.type='button'; bm.textContent=MON3[k];
          bm.setAttribute('aria-label', name);
          if(k===view.m) bm.setAttribute('aria-current','true');
          bm.addEventListener('click', function(){ view.m=k; mode='days'; draw(); });
          ms.appendChild(bm);
        });
        cal.appendChild(ms);
        return;
      }
      if(mode==='years'){
        var ys=document.createElement('div'); ys.className='onz-sub__cal-years';
        for(var y=Y1; y>=Y0; y--){
          (function(yy){
            var b=document.createElement('button'); b.type='button'; b.textContent=yy;
            if(yy===view.y) b.setAttribute('aria-current','true');
            b.addEventListener('click', function(){ view.y=yy; mode='days'; draw(); });
            ys.appendChild(b);
          })(y);
        }
        cal.appendChild(ys);
        return;
      }

      var grid=document.createElement('div'); grid.className='onz-sub__cal-grid';
      DOW.forEach(function(t){
        var c=document.createElement('div'); c.className='onz-sub__cal-dow'; c.textContent=t; grid.appendChild(c);
      });
      var first=new Date(view.y, view.m, 1).getDay();
      var last=new Date(view.y, view.m+1, 0).getDate();
      var prevLast=new Date(view.y, view.m, 0).getDate();
      var cells=[];
      for(var i=first-1;i>=0;i--) cells.push({d:prevLast-i, out:true});
      for(var d=1;d<=last;d++) cells.push({d:d, out:false});
      while(cells.length % 7) cells.push({d:cells.length-first-last+1, out:true});
      cells.forEach(function(c){
        var b=document.createElement('button'); b.type='button';
        b.className='onz-sub__cal-day'+(c.out?' onz-sub__cal-day--out':'');
        b.textContent=c.d;
        if(!c.out){
          if(view.y===NOW.getFullYear() && view.m===NOW.getMonth() && c.d===NOW.getDate())
            b.className+=' onz-sub__cal-day--today';
          if(value && value.y===view.y && value.m===view.m && value.d===c.d)
            b.className+=' onz-sub__cal-day--on';
          b.setAttribute('aria-label', MONTHS[view.m]+' '+c.d+', '+view.y);
          b.addEventListener('click', function(){
            value={y:view.y, m:view.m, d:c.d}; label(); close(); btn.focus();
          });
        } else { b.disabled=true; }
        grid.appendChild(b);
      });
      cal.appendChild(grid);

      var foot=document.createElement('div'); foot.className='onz-sub__cal-foot';
      var clr=document.createElement('button'); clr.type='button'; clr.textContent='Clear';
      clr.addEventListener('click', function(){ value=null; label(); draw(); });
      var tdy=document.createElement('button'); tdy.type='button'; tdy.textContent='Today';
      tdy.addEventListener('click', function(){
        view={y:NOW.getFullYear(), m:NOW.getMonth()};
        value={y:NOW.getFullYear(), m:NOW.getMonth(), d:NOW.getDate()};
        label(); close(); btn.focus();
      });
      foot.appendChild(clr); foot.appendChild(tdy);
      cal.appendChild(foot);
    }
    function shift(step){
      var m=view.m+step, y=view.y;
      if(m<0){ m=11; y--; } else if(m>11){ m=0; y++; }
      view={y:y, m:m}; draw();
    }
    btn.addEventListener('click', function(){
      if(!cal.hidden){ close(); return; }
      if(openCal) openCal.hidden=true;            // 다른 아이의 캘린더는 닫는다
      if(value) view={y:value.y, m:value.m};
      mode='days'; draw(); cal.hidden=false; openCal=cal;
    });
    cal.addEventListener('keydown', function(e){ if(e.key==='Escape'){ close(); btn.focus(); } });

    wrap.getValue = function(){ return value ? iso(value.y, value.m, value.d) : ''; };
    wrap.dateBtn = btn;
    label();
    return wrap;
  }

  function kidRow(i,total){
    var w=document.createElement('div'); w.className='onz-sub__kid';
    var lab=document.createElement('span'); lab.className='onz-sub__kid-label';
    lab.textContent = total>1 ? ('Child '+(i+1)) : '';
    var box=makeDatePicker();
    var del=document.createElement('button');
    del.type='button'; del.className='onz-sub__kid-del'; del.innerHTML='&times;';
    del.setAttribute('aria-label','Remove');
    del.addEventListener('click', function(){ w.remove(); relabel(); });
    w.appendChild(lab); w.appendChild(box);
    if(total>1) w.appendChild(del);
    return w;
  }
  // 순서 이름(Child N)은 **여기서만** 정한다 — 생성 시점 인덱스로 박아두면 행을 지운 뒤
  // 보이는 라벨과 음성 안내가 어긋나고, 다시 추가할 때 같은 번호가 겹친다(실측).
  function relabel(){
    var rows=kids.querySelectorAll('.onz-sub__kid'), n=rows.length;
    rows.forEach(function(r,i){
      var who = n>1 ? ('Child '+(i+1)+' ') : 'Child ';
      r.querySelector('.onz-sub__kid-label').textContent = n>1 ? ('Child '+(i+1)) : '';
      var db=r.querySelector('.onz-sub__date');
      if(db) db.setAttribute('aria-label', who.trim()+' birthday or due date');
      var d=r.querySelector('.onz-sub__kid-del');
      if(n>1 && !d){ var b=document.createElement('button');
        b.type='button'; b.className='onz-sub__kid-del'; b.innerHTML='&times;';
        b.setAttribute('aria-label','Remove '+who.trim());
        b.addEventListener('click', function(){ r.remove(); relabel(); }); r.appendChild(b); }
      else if(d){ d.setAttribute('aria-label','Remove '+who.trim()); }
      if(n<=1 && d){ d.remove(); }
    });
  }
  // 바깥을 누르면 열린 캘린더를 닫는다.
  // ⚠️ 판정은 **capture 단계에서 미리** 한다. 화살표를 누르면 draw() 가 innerHTML 을 비워
  //    눌린 버튼이 DOM 에서 떨어지는데, bubble 단계에서 contains(e.target) 를 보면 이미
  //    분리된 노드라 '바깥' 으로 읽혀 캘린더가 닫혀버린다(실측: ◀ 클릭 → 닫힘).
  document.addEventListener('click', function(e){
    if(!openCal) return;
    var inside = openCal.parentNode.contains(e.target);
    setTimeout(function(){
      if(openCal && !inside){ openCal.hidden=true; openCal=null; }
    }, 0);
  }, true);
  kids.appendChild(kidRow(0,1)); relabel();   // 생성 직후 aria 를 세운다

  addBtn.addEventListener('click', function(){
    if(addBtn.disabled) return;
    kids.appendChild(kidRow(0,2)); relabel();   // 순서 이름은 relabel 이 정한다
  });
  noneBtn.addEventListener('click', function(){
    var on = noneBtn.getAttribute('aria-pressed')==='true';
    var next = !on;
    noneBtn.setAttribute('aria-pressed', next?'true':'false');
    kids.hidden = next; expecting.hidden = !next;     // 날짜 대신 문구 (레퍼런스)
    // 눌리는데 아무 일도 안 일어나면 고장으로 읽힌다 — 못 누르는 상태를 보이게 한다.
    addBtn.disabled = next;
  });

  form.addEventListener('submit', function(ev){
    ev.preventDefault();
    errBox.hidden=true;
    var email=(el.querySelector('#onz-sub-email').value||'').trim();
    if(email.indexOf('@')<0){ errBox.textContent='Please enter a valid email.'; errBox.hidden=false; return; }
    var isExpecting = noneBtn.getAttribute('aria-pressed')==='true';
    var children=[], partial=false;
    if(!isExpecting){
      kids.querySelectorAll('.onz-sub__dob').forEach(function(box){
        var v = box.getValue ? box.getValue() : '';
        if(v) children.push({dob:v}); else partial=true;
      });
      if(partial){
        errBox.textContent='Please pick a date for each child.';
        errBox.hidden=false; return;
      }
    }
    submitBtn.disabled=true; submitBtn.textContent='Subscribing…';
    fetch('https://orbitools.orbiters.co.kr/api/onzenna/blog/subscribe/', {
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({email:email, children:children, is_expecting:isExpecting,
        consent_text:"I agree to receive parenting emails from Onzenna. You can unsubscribe anytime.",
        page: location.pathname})
    }).then(function(r){ return r.json().catch(function(){ return {ok:false}; }); })
      .then(function(d){
        if(d && d.ok){
          form.hidden=true; done.hidden=false;
        } else {
          submitBtn.disabled=false; submitBtn.textContent='Subscribe';
          errBox.textContent = (d && d.error==='suppressed')
            ? 'This address was removed at your request. Please contact us to resubscribe.'
            : 'Something went wrong. Please try again.';
          errBox.hidden=false;
        }
      }).catch(function(){
        submitBtn.disabled=false; submitBtn.textContent='Subscribe';
        errBox.textContent='Network error. Please try again.'; errBox.hidden=false;
      });
  });
})();
